<template>
  <b-modal :id="modalId" :title="modalTitle" centered hide-footer size="xl">
    <iframe
        :id="`iframe${modalId}`"
        ref="iframeRef"
        :src="modalSrc"
        allow="camera;microphone"
        style="width: 100%; height: 100%; min-height: 70vh; border: none"
        title="Tạo đơn"
        @load="onIframeLoad($event)"
    ></iframe>
  </b-modal>
</template>
<script>
import {BModal} from "bootstrap-vue";

export default {
  name: "PopupChoosePhone",
  props: {
    modalId: {
      type: String,
      default: "PopupChoosePhone",
    },
    modalTitle: {
      type: String,
      default: "Tạo đơn",
    },
    modalSrc: {
      type: String,
      default: "http://localhost:8000/mua-hang?iframe=true",
    },
  },
  components: {
    BModal,
  },
  data() {
    return {};
  },
  mounted() {
  },
  methods: {
    onIframeLoad(e) {
      // hideLayout()
      console.log("onIframeLoad", e, this.$refs.iframeRef.contentWindow);
    },
    onOrder(data) {
      console.log("onOrder", data);
    },
  },
};
</script>
